import { render } from "./FooterMod.vue?vue&type=template&id=9d520264&scoped=true&ts=true"
import script from "./FooterMod.vue?vue&type=script&lang=ts"
export * from "./FooterMod.vue?vue&type=script&lang=ts"

import "./FooterMod.vue?vue&type=style&index=0&id=9d520264&scoped=true&lang=sass"

import exportComponent from "/Users/sotenck/GIT/kunden/iconomy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d520264"]])

export default __exports__